import { DroplistItem } from '@eforall/dashboard';
import { StaticDataService } from 'services';
import { LIST } from '../dashboard-list-part/dashboard-list.part.service';


export function getDroplistItems(staticData: StaticDataService): DroplistItem<LIST, number>[] {

	const items: DroplistItem<LIST, number>[] = [
		{
			uniqueId: -1,
			iconContext: { iconClass: 'fa-chart-line', iconStyle: 'fa-regular', text: 'Available Dashboards', hideText: 'never' },
			groupName: 'My',
			customSort: 'a-1',
			data: 'Available',
		},
		{
			uniqueId: -2,
			iconContext: { iconClass: 'fa-chart-line', iconStyle: 'fa-regular', text: 'Personal Dashboards', hideText: 'never' },
			groupName: 'My',
			customSort: 'a-2',
			data: 'Personal'
		},
		{
			uniqueId: -3,
			iconContext: { iconClass: 'fa-chart-line', iconStyle: 'fa-regular', text: 'Recent Dashboards', hideText: 'never' },
			groupName: 'My',
			customSort: 'a-3',
			data: 'Recent',
		},
		{
			uniqueId: -4,
			iconContext: { iconClass: 'fa-chart-line', iconStyle: 'fa-regular', text: 'Starred Dashboards', hideText: 'never' },
			groupName: 'My',
			customSort: 'a-4',
			data: 'Starred',
		},
		{
			uniqueId: -5,
			iconContext: { iconClass: 'fa-chart-line', iconStyle: 'fa-regular', text: 'Trashed Dashboards', hideText: 'never' },
			groupName: 'My',
			customSort: 'a-5',
			data: 'Trashed',
		},
		{
			uniqueId: -6,
			iconContext: { iconClass: 'fa-chart-line', iconStyle: 'fa-regular', text: 'Orphaned Dashboards', hideText: 'never' },
			groupName: 'My',
			customSort: 'a-5',
			data: 'Orphaned',
		},
	];

	const datasets = staticData.datasets.all
		.map(ds => {
			const category = staticData.dataset_categorys.byId(ds.datasetCategoryId);
			return {
				datasetId: ds.id,
				name: ds.name,
				category,
			};
		})
		.sort((a, b) => {
			//
			// Sort by category.sortOrder
			//
			if (a.category.sortOrder !== b.category.sortOrder) {
				return a.category.sortOrder - b.category.sortOrder;
			}

			//
			// Sort by category.name
			//
			const categoryNameCompare = a.category.name.localeCompare(b.category.name);
			if (categoryNameCompare !== 0) return categoryNameCompare;

			//
			// Sort by item.name
			//
			return a.name.localeCompare(b.name);
		});
	

	for (const ds of datasets) {
		items.push({
			uniqueId: ds.datasetId,
			iconContext: { iconClass: 'fa-database', iconStyle: 'fa-regular', text: ds.name, hideText: 'never' },
			groupName: ds.category.name,
			customSort: ds.name,
			data: 'Dataset',
		},);
	}

	return items;
}